export default __webpack_public_path__ + "static/media/pic2.8733a2ef.jpg";